"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeAutoAddonQty = void 0;
/**
 * Figure out the quantity of the auto add-on variant depending on the selMainVariant
 */
var computeAutoAddonQty = function (variant, mainVariant) {
    // for wipes, we assume the number exists in option2 of the main variant
    // e.g., "7 packs + 4 wipes" = 4, "20 packs + 9 wipes" = 9, "7 packs" = 0
    if (variant.name.includes('Wipes') && mainVariant) {
        var wipesMatches = mainVariant.option2.match(/(\d+) Wipes/i);
        return wipesMatches ? Number(wipesMatches[1]) : 0;
    }
    // by default, autoAddOns will be quantity 1
    return 1;
};
exports.computeAutoAddonQty = computeAutoAddonQty;
